import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root',
})
export class ProcedimentoService extends AbstractCrudService {
  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'procedimento';
  }

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'procedimento';
  }

  listarExamesDTO(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/listarExamesDTO`);
  }

  listarExamesPorPlanoSaudeDTO(idPlanoSaude: number): Observable<any> {
    return this.http.get(
      `${this.getBaseUrlPublic()}/listarExamesDTO/planoSaude/${idPlanoSaude}`
    );
  }

  listarComProjecao(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/comProjecao`);
  }

  listarConflitosPeloProcedimentoPrincipalComProjecao(
    idProcedimento: number
  ): Observable<any> {
    return this.http.get(
      `${this.getBaseUrlPrivate()}/conflitos/comProjecao/${idProcedimento}`
    );
  }

  // listarTodosExamesPorProcedimento(
  //   idProcedimento: number,
  //   idPlanoSaude: number,
  //   idPaciente: number,
  //   portadorNecessidade: boolean
  // ): Observable<any> {
  //   return this.http.get(
  //     `${this.getBaseUrlPublic()}/listarTodosExames/procedimento/${idProcedimento}/planoSaude/${idPlanoSaude}/paciente/${idPaciente}?portadorNecessidade=${portadorNecessidade}`
  //   );
  // }
}
